import React from "react";

import { Routes, Route } from "react-router-dom";

import { Paper, Grid } from "@mui/material";
import { MainLayout } from "pages/layouts";
import NotFound from "pages/not-found";

import FormPage from "./pages/form";
import SuccessPage from "./pages/success";


const LinkApp: React.FC = () => (
  <MainLayout
    showHeader
    showFooter
    backgroundColor="gray"
  >
    <Grid container spacing={2} justifyContent="center">
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper>
          <div style={{ padding: "0.5em 3em 2em" }}>
            <Routes>
              <Route index element={<FormPage />} />
              <Route path=":linkCode" element={<FormPage />} />
              <Route path="success" element={<SuccessPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Paper>
      </Grid>
    </Grid>
  </MainLayout>
);

export default LinkApp;
